import useScreenSize from '@/hooks/useScreenSize';
import useTranslations from '@/i18n/useTranslations';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import Heading from '@/shared-components/text/components/Heading';

import './styles/HomeBanner.css';

export default function HomeBanner({
  mobileImage,
  desktopImage,
  onClick,
  alt,
  title,
  description,
  buttonText = '',
}) {
  const tHome = useTranslations('common.shared.home');
  const { width } = useScreenSize();
  const imageSrc = width <= 550 ? mobileImage : desktopImage;

  return (
    <div className="home-banner" onClick={onClick}>
      <ArtworkImage
        image={imageSrc}
        imageClassName="home-banner__banner"
        imageTemplateClassName="home-banner__banner"
        alt={alt}
      />
      <div className="home-banner__overlay" />
      <div className="home-banner__content">
        <div className="home-banner__text">
          <Heading className="home-title">{title}</Heading>
          <p className="home-banner__description">{description}</p>
        </div>
        <button className="home-banner__button">{buttonText || tHome('discover')}</button>
      </div>
    </div>
  );
}
